import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './ForgotPasswordPage.module.css';
import apiRequest from '../../lib/apiRequest';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    try {
      const res = await apiRequest.post(
        '/auth/forgot-password',
        { email }
      );
      setMessage(
        res.data.message || 'Password reset email sent. Please check your inbox.'
      );
    } catch (err) {
        if(err.response && err.response.status === 429) {
            // This error is due to too many requests.
            setError(err.response.data.message || 'Too many requests, please try again in a minute.');
            return;
        }
      setError(
        err.response?.data?.message || 'Failed to send reset email. Please try again later.'
      );
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Forgot Password</h2>
      <form onSubmit={handleSubmit} className={styles.form}>
        <label htmlFor="email" className={styles.label}>
          Enter your email address:
        </label>
        <input
          type="email"
          id="email"
          className={styles.input}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" className={styles.button}>
          Send Reset Link
        </button>
      </form>
      {message && <p className={styles.successMessage}>{message}</p>}
      {error && <p className={styles.errorMessage}>{error}</p>}
      <p className={styles.backLink}>
        <button onClick={() => navigate('/login')} className={styles.linkButton}>
          Back to Login
        </button>
      </p>
    </div>
  );
};

export default ForgotPasswordPage;
